import React from "react";

import IconArrowRight from "../../../containers/assets/icon-arrow-right.svg";
import PeerRatingIntro from "../../../containers/assets/peer_rating_intro.svg";
import SelfAssessmentIntro from "../../../containers/assets/self_assessment_intro.svg";
import SkillsAssessmentIntro from "../../../containers/assets/skills_assessment_intro.svg";
import FinalPageImage from "../../../containers/assets/final-page.svg";
import TextArea from "../text-area";
import LikertScale from "../likert-scale";
import TeamList from "../team-list";
import LikertScaleTable from "../likert-scale-table";
import TeamTable from "../team-table";
import MultiSelect from "../multi-select";
import LikeWishResults from "../like-wish-results";
import Bars from "../bars";
import cn from "classnames";
import Teams from "../../../api/Teams";

const selfAssessmentIntroText = (
  <p>
    Answer a few questions to let the instructor know how you feel in the game
    so far.
  </p>
);

const peerRatingIntroText = (
  <p>
    Answer a few questions to evaluate how your teammates are collaborating.
    Your answers are <span>anonymous</span>.
  </p>
);

const peerRatingFeedbackIntroText = (
  <p>
    Here's how your teammates rated your collaboration skills.
  </p>
);

const skillsAssessmentText = (
  <p>
    This section <span>does not impact your teammates grade</span>. The main purpose is to let your teammates know what they are doing well. This helps them to be aware of the team skills that they are demonstrating as well as focus on areas to improve.
  </p>
);

const FinalReflectionsText = (
  <p>
    This section <span>does not impact your teammates grade</span> and your <span>feedback is only visible to your instructor</span>. The main purpose is to let your instructor know the level of collaboration within your team. This helps your instructors improve the overall learning experience.
  </p>
);

const finalPageText = (adjustedScore) => {
  const text = adjustedScore === 1
    ? 'You\'ve earned 100% of your feedback submission score. Please encourage your teammates to submit by the deadline or they\'ll lose points.'
    : `You've earned ${adjustedScore * 100}% of your feedback submission score since you've submitted it by the deadline.`;
  return (
    <div>
      <p>
        Congratulation on completing your peer evaluation!
      </p>
      <br />
      <p>{text}</p>
    </div>
  )
}

const iLikeTitle = (
  <h5 className="title">Here's what <span>Sophie</span> did well.</h5>
);

const iWishTitle = (
  <h5 className="title">Here's what <span>Sophie</span> can improve.</h5>
);

const transitionPageText = (username) => (
  <p style={{ textAlign: 'center' }}>{username}</p>
)

const GenerateIntroScreen = props => {
  const {
    title,
    imgSrc,
    text,
    tagText,
    background,
    backgroundBlockWidth = '780',
    showTeamCircle = false,
    teamCircleBackground
  } = props;

  return (
    <div className="feedbackIntroScreen">
      <div
        className={cn({
          backgroundImage: !!background,
        })}
        style={{
          backgroundColor: background,
          width: backgroundBlockWidth,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        {imgSrc && <img alt="Intro img" src={imgSrc} />}
        {
          showTeamCircle &&
          <div style={{ borderRadius: '50%', width: 140, height: 140, backgroundColor: teamCircleBackground }}></div>
        }
      </div>
      <div className="introScreenInfo">
        {title && <div className="introScreenInfo__title">
          <img alt="right arrow" src={IconArrowRight} />
          {title}
          {tagText && <div className="tag">{tagText}</div>}
        </div>}
        <div className={cn("introScreenInfo__text", {
          "introScreenInfo__notitle": !title,
        })}>{text}</div>
      </div>
    </div>
  );
};

const statementsColors = [
  '#52c5cd',
  '#00b0ff',
  '#f7d48f',
  '#bfa4fc',
  '#f27676',
  '#78cc7b',
  '#f2b682',
  '#81d9f1',
  '#81efe8',
  '#ebed80',
];
const prepareStatements = (statements) => (
  <div className="coloredText">
    {statements.map((statement, index) => (
      <span key={index} style={{ color: statementsColors[index % statementsColors.length] }}>{statement}{index === statements.length - 1 ? '.' : ';'} </span>
    ))}
  </div>
);

const parseFeedback = props => {
  const {
    question,
    answers,
    self_assessment_count,
    peer_rating_count,
    showError,
    onChange,
    teamList,
    currentUserId,
    feedbacks,
    previousAnswers,
    readonlyMode,
    adjustedScore
  } = props;

  const teamColorCircle = Teams.currentTeamColor();
  const teamColorBackground = Teams.currentTeamColorLevel1();

  switch (question.answer_type) {
    case "self_assessment_intro":
      return (
        <GenerateIntroScreen
          title="Self Assessment"
          imgSrc={SelfAssessmentIntro}
          text={selfAssessmentIntroText}
          tagText={`${self_assessment_count} questions`}
        />
      );
    case "self_assessment_results_intro":
      return (
        <GenerateIntroScreen
          title="Self Assessment"
          imgSrc={SelfAssessmentIntro}
          text=""
          tagText={`${self_assessment_count} questions`}
        />
      );
    case "peer_rating_intro":
      return (
        <GenerateIntroScreen
          title="Peer Rating"
          imgSrc={PeerRatingIntro}
          text={peerRatingIntroText}
          tagText={`${peer_rating_count} criteria`}
        />
      );
    case "peer_rating_feedback_intro":
      return (
        <GenerateIntroScreen
          title="Peer Rating"
          imgSrc={PeerRatingIntro}
          text={peerRatingFeedbackIntroText}
          tagText={`${peer_rating_count} criteria`}
        />
      );
    case "final_reflection_feedback_intro":
        return (
          <GenerateIntroScreen
            title="Final Reflections"
            imgSrc={SkillsAssessmentIntro}
            text={''}
            tagText={`${peer_rating_count} criteria`}
          />
        );
    case "ilike":
        return (
          <LikeWishResults
            id={question.id}
            header={iLikeTitle}
            items={question.answers}
          />
        );
    case "iwish":
        return (
          <LikeWishResults
            id={question.id}
            header={iWishTitle}
            items={question.answers}
          />
        );
    case "skills_assessment_intro":
      return (
        <GenerateIntroScreen
          title="Skills Assessment"
          imgSrc={SkillsAssessmentIntro}
          text={skillsAssessmentText}
        />
      );
    case "final_reflections_intro":
      return (
        <GenerateIntroScreen
          title="Final Reflections"
          imgSrc={SkillsAssessmentIntro}
          text={FinalReflectionsText}
        />
      );
    case "final_reflections_results_intro":
      return (
        <GenerateIntroScreen
          title="Final Reflections"
          imgSrc={SkillsAssessmentIntro}
          text=""
        />
      );
    case "final_page":
      return (
        <GenerateIntroScreen
          title={null}
          imgSrc={FinalPageImage}
          background="#D7F0F2"
          text={finalPageText(adjustedScore)}
        />
      );
    case "final_peer_rating_page":
      return (
        <GenerateIntroScreen
          title={null}
          imgSrc={FinalPageImage}
          background="#D7F0F2"
        />
      );
    case "transition_page":
      return (
        <GenerateIntroScreen
          title={null}
          imgSrc={null}
          background={teamColorBackground}
          backgroundBlockWidth={280}
          showTeamCircle={true}
          teamCircleBackground={teamColorCircle}
          text={transitionPageText(question.username)}
        />
      );
    case "freeform":
      if (question.category === "self_assessment" && question.text.indexOf("most valuable") === -1) {
        const feedback = feedbacks[currentUserId] ? feedbacks[currentUserId].id : null;
        const answer = feedback ? answers.find(i => i.feedback === feedback) : null;

        const value = feedback
          ? answer
            ? answer.value
            : ''
          : question.value
            ? question.value
            : '';

        return (
          <TextArea
            id={question.id}
            title={question.text}
            onChange={onChange}
            showError={showError}
            value={value}
            feedback={feedback || 0}
            readonlyMode={readonlyMode}
          />
        );
      }

      if (question.category === "self_assessment" && question.text.indexOf("most valuable") >= 0) {
        const feedback = feedbacks[currentUserId] ? feedbacks[currentUserId].id : null;
        const answer = feedback ? answers.find(i => i.feedback === feedback) : null;

        return (
          <TeamList
            id={question.id}
            title={question.text}
            onChange={onChange}
            value={answer ? answer.value : ""}
            teamList={teamList}
            feedback={feedback || 0}
            readonlyMode={readonlyMode}
          />
        );
      }

      if (question.category === "collaboration" || question.category === "peer_rating") {
        let feedbacksIds = [];
        for (const userId of teamList.map(teammate => teammate.id)) {
          if (feedbacks[userId]) {
            feedbacksIds.push(feedbacks[userId].id);
          }
        }
        const teamAnswers = answers.filter(i => feedbacksIds.includes(i.feedback)).map(i => ({
          feedback: i.feedback,
          value: i.value
        }));

        return (
          <TeamTable
            id={question.id}
            title={question.text}
            onChange={onChange}
            values={teamAnswers}
            teamList={teamList}
            feedbacks={feedbacks}
            readonlyMode={readonlyMode}
          />
        );
      }

      if (question.category === "communication") {
        const feedback = feedbacks[question.userId] ? feedbacks[question.userId].id : null;
        const answer = feedback ? answers.find(i => i.feedback === feedback) : null;

        const leftExtraInfo = question.answer_type === "freeform"
          ? (
            <div>
              <p><b>Consider any of the following in your response:</b></p>
              <ul>
                <li>The effectiveness of this teammate's communication, whether in person or via email.</li>
                <li>The level of preparedness demonstrated by this teammate during team meetings.</li>
                <li>The extent to which this teammate adeptly employed and/or analyzed data during discussions or decision-making.</li>
                <li>The degree of supportiveness exhibited by this teammate.</li>
                <li>How well this teammate listened to your ideas and those of others.</li>
                <li>How adeptly this teammate managed conflicts.</li>
                <li>The extent to which this teammate is open to considering multiple options and perspectives while making decisions.</li>
              </ul>
            </div>
          )
          : null;

        return (
          <TextArea
            id={question.id}
            title={question.text}
            onChange={onChange}
            showError={showError}
            value={answer ? answer.value : ""}
            feedback={feedback || 0}
            text={previousAnswers && previousAnswers.length > 0 && question.answer_type !== "freeform" ? prepareStatements(previousAnswers) : null}
            readonlyMode={readonlyMode}
            leftExtraInfo={leftExtraInfo}
          />
        );
      }

      if (question.category === "other" || question.category === "skills") {
        const feedback = feedbacks[question.userId] ? feedbacks[question.userId].id : null;
        const answer = feedback ? answers.find(i => i.feedback === feedback) : null;

        return (
          <MultiSelect
            id={question.id}
            title={question.text}
            onChange={onChange}
            value={answer ? answer.value : ""}
            feedback={feedback || 0}
            statements={question.statements ? [
              ...question.statements,
              { id: 0, text: 'Not Applicable' },
            ] : []}
            readonlyMode={readonlyMode}
          />
        );
      }

      if (question.category === "like_wish_results") {
        return (
          <LikeWishResults
            id={question.id}
            title={question.text}
            items={question.items}
          />
        );
      }

      return <div>{question.category} - {question.answer_type}</div>;
    case "rating": {
      if (question.assessment_type === "bars") {

        let feedback = 0;
        let answersValue = 0;

        if (question.category === "self_assessment") {
          feedback = feedbacks[currentUserId] ? feedbacks[currentUserId].id : null;
          const answer = feedback ? answers.find(i => i.feedback === feedback) : 0;
          answersValue = answer ? answer.value : 0;
        } else {
          let feedbacksIds = [];
          for (const userId of teamList.map(teammate => teammate.id)) {
            if (feedbacks[userId]) {
              feedbacksIds.push(feedbacks[userId].id);
            }
          }
          answersValue = answers.filter(i => feedbacksIds.includes(i.feedback)).map(i => ({
            feedback: i.feedback,
            value: i.value
          }));
        }

        return (
          <Bars
            id={question.id}
            title={question.text}
            onChange={onChange}
            options={question.option_choices}
            teamList={teamList}
            readonlyMode={readonlyMode}
            category={question.category}
            feedback={feedback || 0}
            feedbacks={feedbacks}
            values={answersValue}
          />
        );
      } else {
        if ((question.category === "self_assessment" || question.category === "likert") && !question.most_valuable) {
          const feedback = feedbacks[currentUserId] ? feedbacks[currentUserId].id : null;
          const answer = feedback ? answers.find(i => i.feedback === feedback) : null;
          const value = question.category === "likert"
            ? question.value
            : answer
              ? answer.value
              : 0;

          return (
            <LikertScale
              id={question.id}
              title={question.text}
              onChange={onChange}
              value={value}
              feedback={feedback || 0}
              readonlyMode={readonlyMode}
            />
          );
        }

        if ((question.category === "collaboration" || question.category === "peer_rating") && !question.most_valuable) {
          let feedbacksIds = [];
          for (const userId of teamList.map(teammate => teammate.id)) {
            if (feedbacks[userId]) {
              feedbacksIds.push(feedbacks[userId].id);
            }
          }
          const teamAnswers = answers.filter(i => feedbacksIds.includes(i.feedback)).map(i => ({
            feedback: i.feedback,
            value: i.value
          }));

          return (
            <LikertScaleTable
              id={question.id}
              title={question.text}
              onChange={onChange}
              values={teamAnswers}
              teamList={teamList}
              feedbacks={feedbacks}
              readonlyMode={readonlyMode}
            />
          );
        }
      }

      return <div />;
    }
    default:
      return <div />;
  }
};

export default parseFeedback;



// WEBPACK FOOTER //
// ./src/components/peer-evaluation/peer-evaluation-feedback/parseFeedback.js